<script lang="ts">
	import { Router, Route } from "svelte-navigator";
	import Callback from "./authentication/Callback.svelte";
	import Silent from "./authentication/Silent.svelte";
	import Login from "./authentication/Login.svelte";
	import Logout from "./authentication/Logout.svelte";
	import { appManager } from "./AppManager";
	import { onMount } from "svelte";
	import { _, getLocaleFromNavigator, init, addMessages } from "svelte-i18n";
	import en from "./locales/en.json";
	import nl from "./locales/nl.json";
    import ModelView from "./models/ModelView.svelte";

	// Locale setup
	addMessages("en", en);
	addMessages("nl", nl);
	init({
		fallbackLocale: "en",
		initialLocale: getLocaleFromNavigator(),
	});

	// initialize app with settings.
	const publicUrl = new URL("process.env.BASEURL");
	appManager.initialize({
		publicUrl: publicUrl,
	}, {
		editApi: {
			url: "process.env.EDIT_API"
		},
		identityApi: "process.env.AUTHORITY",
		projectApi: {
			url: "process.env.PROJECT_API"
		},
		tripsApi: {
			url: "https://api.anyways.eu/data/trips/canary/"
			//url: "http://localhost:5001/"
		}
	});

	let infoShown: boolean = false;
	let infoOnMap: boolean = true;
	let location: boolean = false;
	let segment: boolean = false;
	let search: boolean = true;
	let searchCollapsed: boolean = false;
	let isSmall: boolean = false;
	let createOpen: boolean = false;

	$: createOpen = searchCollapsed;

	$: {
		if (isSmall) {
			if (
				typeof window !== "undefined" &&
				window.localStorage.getItem("infoShown") === "true"
			) {
				infoShown = true;
			} else {
				infoShown = false;
			}
			infoOnMap = !infoShown;

			if (location || segment) {
				infoOnMap = false;
			}

			search = !infoOnMap;
		} else {
			if (!location && !segment) {
				infoOnMap = true;
			} else {
				infoOnMap = false;
			}
			search = true;
		}

		if (location || segment) {
			searchCollapsed = true;
		}
	}
	appManager.isSmall.subscribe((v) => {
		isSmall = v;
	});

	onMount(() => {
		if (document.body.clientWidth < 576) {
			appManager.isSmall.set(true);
		} else {
			appManager.isSmall.set(false);
		}
	});
</script>

<svelte:head>
	<title>{$_("title")} | {$_("subtitle")}</title>
</svelte:head>

<Router basepath={publicUrl.pathname ?? ""}>
	<Route path="/">
		<ModelView modelGlobalId={"eb380de7-f143-4799-9765-0d7a1d9c7717"}/>
	</Route>

	<Route path="model/:id" let:params>
		<ModelView modelGlobalId={params.id} />
	</Route>

	<Route path="callback">
		<Callback />
	</Route>

	<Route path="silent">
		<Silent />
	</Route>

	<Route path="logout">
		<Logout />
	</Route>

	<Route path="login">
		<Login />
	</Route>
</Router>
